import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FadeIn, MaskedLineScroll, Overline } from "@/components/Reveal";

export const FAQ_ITEMS = [
  {
    q: "Le déplacement et le devis sont-ils vraiment gratuits ?",
    a: "Oui. MSC Toitures se déplace gratuitement partout dans le Val-de-Marne (94) pour examiner votre toiture, et le devis qui suit est gratuit et sans engagement. Vous savez exactement ce qui est proposé avant de vous décider.",
  },
  {
    q: "Comment savoir si ma toiture fuit ?",
    a: "Les signes les plus courants : une tache d'humidité au plafond ou le long d'un mur, des peintures qui cloquent, un goutte-à-goutte dans les combles les jours de pluie, ou une odeur d'humidité persistante. Attention : l'endroit où l'eau apparaît est rarement l'endroit où elle entre — d'où l'importance d'une recherche de fuite par un couvreur.",
  },
  {
    q: "Une tuile cassée, est-ce vraiment grave ?",
    a: "Une tuile cassée ne fait pas toujours couler immédiatement, mais elle laisse passer l'eau sous la couverture. À terme, l'humidité attaque les liteaux, l'isolant et la charpente. Remplacer une tuile coûte peu ; réparer une charpente humide coûte beaucoup plus. Mieux vaut intervenir tôt.",
  },
  {
    q: "Ma gouttière déborde dès qu'il pleut, que faire ?",
    a: "Un débordement vient le plus souvent d'une gouttière bouchée (feuilles, mousse), d'une pente insuffisante ou d'un joint qui fuit. Ne laissez pas l'eau couler le long de la façade : elle tache les murs et peut s'infiltrer. Nous réparons et remplaçons gouttières, chéneaux et descentes dans tout le 94.",
  },
  {
    q: "Intervenez-vous dans ma ville ?",
    a: "Nous intervenons dans tout le Val-de-Marne : Champigny-sur-Marne, Saint-Maur-des-Fossés, Nogent-sur-Marne, Créteil, Maisons-Alfort, Vitry-sur-Seine, Villejuif, Thiais, Ivry-sur-Seine et toutes les autres communes du 94. Notre showroom est au 34 boulevard de Polangis à Champigny-sur-Marne.",
  },
  {
    q: "Quel est le prix d'une réparation de toiture ?",
    a: "Il n'existe pas de tarif unique : remplacer quelques tuiles n'a rien à voir avec reprendre une noue ou une zinguerie complète. Le prix dépend du désordre, de l'accès à la toiture et des matériaux. C'est précisément pour cela que le déplacement et le devis sont gratuits — vous savez exactement ce qui est nécessaire, et à quel prix, avant de vous engager.",
  },
  {
    q: "Quels travaux de zinguerie réalisez-vous ?",
    a: "Tous les travaux de zinguerie courants : réparation et remplacement de gouttières pendantes ou encaissées, chéneaux, noues, descentes, abergements de cheminée et de velux, solins et raccords. Nous façonnons les éléments aux dimensions réelles de votre toiture.",
  },
  {
    q: "Comment se passe une demande de devis ?",
    a: "Appelez-nous au 06 46 30 03 91 ou au 01 87 07 86 62, ou remplissez le formulaire en ligne (vous pouvez joindre une photo de votre toiture). Nous convenons d'un rendez-vous, nous examinons votre toiture sur place, puis vous recevez un devis détaillé et gratuit.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-bone py-24 md:py-32 border-b border-midnight/10" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Overline>Questions fréquentes</Overline>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
            <MaskedLineScroll>Vos questions sur</MaskedLineScroll>
            <MaskedLineScroll delay={0.12}>votre <span className="text-signal">toiture</span></MaskedLineScroll>
          </h2>
          <FadeIn delay={0.2}>
            <p className="mt-6 text-base text-midnight/70 leading-relaxed">
              Fuite, tuile cassée, gouttière qui déborde : les réponses aux questions que nous
              posent le plus souvent les propriétaires du Val-de-Marne.
            </p>
          </FadeIn>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <FadeIn delay={0.15}>
            <Accordion type="single" collapsible className="border-t border-midnight/10" data-testid="faq-accordion">
              {FAQ_ITEMS.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-midnight/10">
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="py-6 text-left font-display font-extrabold uppercase tracking-tight text-base md:text-lg hover:text-signal hover:no-underline transition-colors duration-300"
                  >
                    <span className="flex items-start gap-4">
                      <span className="font-mono text-xs text-signal mt-1.5">{String(i + 1).padStart(2, "0")}</span>
                      {item.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-sm md:text-base text-midnight/70 leading-relaxed pl-9 pr-4" data-testid={`faq-answer-${i}`}>
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
